<template>
  <v-dialog
    v-model="showModal"
    persistent
    fullscreen
  >
    <div class="content-section">
      <br>
      <h1 class="header-style">
        Filter Activities
      </h1>

      <p class="subheader-style">
        Select start date and end date for filtering
      </p>
      <br>
      <v-form>
        <v-dialog
          ref="fromDialog"
          v-model="fromCalendar"
          :return-value.sync="fromDate"
          width="290px"
        >
          <template #activator="{ on, attrs }">
            <v-text-field
              v-model="fromDate"
              outlined
              readonly
              color="#000000"
              dense
              light
              prepend-inner-icon="mdi-calendar-month-outline"
              v-bind="attrs"
              placeholder="From"
              v-on="on"
            />
          </template>
          <v-date-picker
            v-if="fromCalendar"
            v-model="fromDate"
            full-width
            color="#37474F"
            light
            :max="maxStartDate"
            @input="$refs.fromDialog.save(fromDate)"
          >
            <v-spacer />
            <v-btn
              text
              color="#37474F"
              @click="fromCalendar = false"
            >
              Cancel
            </v-btn>
          </v-date-picker>
        </v-dialog>
        <v-dialog
          ref="toDialog"
          v-model="toCalendar"
          :return-value.sync="toDate"
          width="290px"
        >
          <template #activator="{ on, attrs }">
            <v-text-field
              v-model="toDate"
              outlined
              prepend-inner-icon="mdi-calendar-month-outline"
              color="#000000"
              dense
              readonly
              light
              placeholder="To"
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <v-date-picker
            v-if="toCalendar"
            v-model="toDate"
            full-width
            color="#37474F"
            light
            :min="minEndDate"
            :max="maxEndDate"
            @input="$refs.toDialog.save(toDate)"
          >
            <v-spacer />
            <v-btn
              text
              color="#37474F"
              @click="toCalendar = false"
            >
              Cancel
            </v-btn>
          </v-date-picker>
        </v-dialog>
      </v-form>
      <v-btn
        color="#000 "
        class="btn-style"
        elevation="0"
        @click="filterActivities()"
      >
        Filter
      </v-btn>
      <v-btn
        light
        color="#E6E6E6"
        class="mt-3 btn-style"
        elevation="0"
        @click="showModal = false"
      >
        Cancel
      </v-btn>
    </div>
    <centre-spinner :loading="loading" />
  </v-dialog>
</template>
<script>
import Constants from 'src/constants';
import spinner from 'src/views/components/SpinnerCentre';
import moment from 'moment';

export default {
  name: 'FilterUserActivities',
  components: {
    'centre-spinner': spinner,
  },
  data () {
    return {
      showModal: true,
      fromDate: null,
      fromCalendar: false,
      toDate: null,
      toCalendar: false,
      loading: false,
      maxEndDate: moment().format('YYYY-MM-DD'),
    };
  },
  computed: {
    minEndDate () {
      return moment(this.fromDate).format('YYYY-MM-DD');
    },
    selectedOrganization () {
      return this.$store.getters.getSelectedOrganization;
    },
    maxStartDate () {
  if (
    !this.selectedOrganization ||
    !this.selectedOrganization.deactivated_at
  ) {
    return null;
  }

  const date = new Date(this.selectedOrganization.deactivated_at);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
},
  },
  watch: {
    showModal: function (newval, oldval) {
      if (newval === false) {
        this.$emit('closed');
      }
    },
  },
  methods: {
    convertToGmt (date) {
      return moment(date).utc();
    },
    getUTCStartDateRangeFromLocalDate (localDate) {
  const fromStart = localDate
    ? moment(localDate + ' 00:00:00', 'YYYY-MM-DD hh:mm:ss')
        .utc()
        .format()
    : '';
  const fromEnd = localDate
    ? moment(localDate + ' 23:59:59', 'YYYY-MM-DD hh:mm:ss')
        .utc()
        .format()
    : '';
  return { fromStart, fromEnd };
},

getUTCEndDateRangeFromLocalDate (localDate) {
  const toStart = localDate
    ? moment(localDate + ' 00:00:00', 'YYYY-MM-DD hh:mm:ss')
        .utc()
        .format()
    : '';
  const toEnd = localDate
    ? moment(localDate + ' 23:59:59', 'YYYY-MM-DD hh:mm:ss')
        .utc()
        .format()
    : '';
  return { toStart, toEnd };
},

async filterActivities () {
  if (!this.fromDate || !this.toDate) {
    this.$store.dispatch(
      'alert/onAlert',
      {
        message: 'Please select from and to dates before proceeding.',
        type: Constants.ALERT_TYPE_ERROR,
      },
      { root: true },
    );
    return;
  }
  this.loading = true;

  const { fromStart } = this.getUTCStartDateRangeFromLocalDate(this.fromDate);
  const { toEnd } = this.getUTCEndDateRangeFromLocalDate(this.toDate);

  await this.$store.dispatch('userprofile/fetchFilteredActivities', {
    params: {
      organizationId: this.selectedOrganization.organization.external_id,
      from: fromStart,
      to: toEnd,
      startPage: 0,
      limit: 5,
    },
  });

  const data = {
    checkInTime: fromStart,
    checkOutTime: toEnd,
  };

  this.$emit('selectedTime', data);

  this.loading = false;
  this.showModal = false;
},

  },
};
</script>
